import { useState } from 'react';
import { RouterProvider, type DataRouter } from 'react-router';

import type { AuthenticationApi } from './auth/api';
import type { AuthenticationMode } from './auth/authState';
import { AppErrorBoundary } from './errors/AppErrorBoundary';
import { AppProviders } from './providers/AppProviders';
import { createAppBrowserRouter } from './router';

interface AppProps {
  authenticationApi?: AuthenticationApi | undefined;
  initialAuthenticationMode?:
    | Extract<AuthenticationMode, 'local'>
    | undefined;
  initialPasswordResetToken?: string | null | undefined;
  router?: DataRouter;
}

export function App({
  authenticationApi,
  initialAuthenticationMode,
  initialPasswordResetToken,
  router,
}: AppProps) {
  const [ownedRouter] = useState(
    () =>
      router ??
      createAppBrowserRouter({
        authenticationApi,
        initialAuthenticationMode,
        initialPasswordResetToken,
      }),
  );
  const appRouter = router ?? ownedRouter;

  return (
    <AppErrorBoundary>
      <AppProviders>
        <RouterProvider router={appRouter} />
      </AppProviders>
    </AppErrorBoundary>
  );
}
